import React from 'react';

type Range = { start: string; end: string };
type DayMap = Record<string, Range[]> | null | undefined;

const DAY_LABELS = ['월', '화', '수', '목', '금', '토', '일'];

const fmt = (rs: Range[] | undefined): string => {
  const valid = (rs || []).filter((r) => r && r.start && r.end);
  if (valid.length === 0) return '휴일';
  return valid
    .slice()
    .sort((a, b) => a.start.localeCompare(b.start))
    .map((r) => `${r.start.slice(0, 5)}~${r.end.slice(0, 5)}`)
    .join(', ');
};

/**
 * 스케줄 변경 요청 내용을 '현재 → 요청' 으로 보여준다.
 * 원장이 승인 전에 무엇이 바뀌는지 확인할 수 있어야 한다 (2026-08-14 송파점 문의).
 */
const ScheduleChangeTable: React.FC<{
  current: DayMap;
  next: DayMap;
  compact?: boolean;
  title?: string;
  nextLabel?: string;
}> = ({
  current,
  next,
  compact,
  title = '요청 내용',
  nextLabel = '요청',
}) => {
  if (!next) return null;
  const rows = DAY_LABELS.map((label, i) => {
    const key = String(i);
    const before = fmt(current?.[key]);
    const after = fmt(next?.[key]);
    return { label, before, after, changed: before !== after };
  });
  const changedCount = rows.filter((r) => r.changed).length;

  return (
    <div style={{ marginTop: 10 }}>
      <div style={{ fontSize: 12, color: '#92400e', marginBottom: 4 }}>
        {title} {changedCount > 0 ? `— ${changedCount}개 요일 변경` : '— 현재와 동일'}
      </div>
      <table style={{ borderCollapse: 'collapse', fontSize: compact ? 12 : 13, width: '100%', maxWidth: 520 }}>
        <thead>
          <tr style={{ color: '#6b7280' }}>
            <th style={{ textAlign: 'left', padding: '3px 8px', width: 34, fontWeight: 600 }}>요일</th>
            <th style={{ textAlign: 'left', padding: '3px 8px', fontWeight: 600 }}>현재</th>
            <th style={{ textAlign: 'left', padding: '3px 8px', fontWeight: 600 }}>{nextLabel}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.label} style={{ background: r.changed ? '#fff7ed' : 'transparent' }}>
              <td style={{ padding: '3px 8px', fontWeight: 700, color: '#374151' }}>{r.label}</td>
              <td style={{ padding: '3px 8px', color: '#6b7280' }}>{r.before}</td>
              <td
                style={{
                  padding: '3px 8px',
                  fontWeight: r.changed ? 700 : 400,
                  color: r.changed ? '#b45309' : '#6b7280',
                }}
              >
                {r.changed ? r.after : '그대로'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ScheduleChangeTable;
